/**
 * Engraving Configuration Constants
 * Shared configuration for engraving text scaling across modal and basket displays
 * 
 * These values determine how engraving text scales relative to image width
 * UK and US products may have different font requirements
 */

const EngravingConfig = {
  // Base font size for 400px width reference
  BASE_FONT_SIZE: 12,
  
  // Base width reference for scaling calculations
  BASE_WIDTH: 400,
  
  // Base max width for text container at 400px reference
  // This controls text wrapping behavior
  BASE_MAX_WIDTH: 76,
  
  // Maximum image width for scaling calculations
  MAX_IMAGE_WIDTH: 320,
  
  // Plate width constant used in scaling calculations
  PLATE_WIDTH_DIVISOR: 146
};

// Make available globally for use in both modal and basket
window.EngravingConfig = EngravingConfig;
